// Generated by CoffeeScript 2.7.0
var Month;

export default Month = {
  props: {
    displayRange: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initValue: {
      type: Date,
      default: function() {
        return new Date();
      }
    }
  },
  template: `<div class="picker-view">
  <div class="picker-row" v-for='(months, index) in displayRange' :key='index'>
    <div class="picker-item"
          v-for='m in months'
          :class="computeItemClass(m)"
          :key='m.key'
          @click='update(m)'>
      <div class="picker-value">{{ m.text + 1 }}月</div>
    </div>
  </div>
</div>`,
  methods: {
    update: function(m) {
      return this.$emit('update', m);
    },
    computeItemClass: function(m) {
      return [
        m.status,
        {
          active: this.initValue.strftime('YYYY-MM') === m.key
        }
      ];
    }
  }
};
